import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autorun} from 'mobx';
import {inject, observer} from 'mobx-react';
import device from 'current-device';
import * as d3 from 'd3';
import {getCursorLocationAngle} from '../../../utils/svgUtility';
import {createD3Arc, getOuterRadius} from './studioUtility';

@inject('studioStore')
@observer
class StudioPlayerSeekCursor extends Component {
    componentDidMount() {
        if (!this.props.mobileView) {
            this.pathEl = d3.select('.studio-player-seek-cursor');
            this.pathEl.on('mousedown', this.handleClick);
        }
        const {studioStore} = this.props;
        this.listener = autorun(() => {
            this.updateCursor(studioStore.advancedMode);
        });
    }

    componentWillUnmount() {
        if (this.listener) {
            this.listener();
        }
    }

    updateCursor = (advancedMode) => {
        const innerRadius = advancedMode ? getOuterRadius(6) + 4 : 0;
        this.circularArc = this.props.mobileView ? createD3Arc(390, 75, 0, 360) : createD3Arc(innerRadius, getOuterRadius(9) + 4, 0, 360);
        d3.select('.studio-player-seek-path').remove();
        this.circularPath = d3.select('#studio-player-cursor-g').append('path')
            .attr('class', 'studio-player-seek-path')
            .attr('d', this.circularArc);
        this.circularPath.on('click', this.handleClick);
        if (!this.props.mobileView) {
            this.circularPath.on('mousemove', this.moveCursor);
            this.circularPath.on('mouseenter', this.showCursor);
            this.circularPath.on('mouseleave', this.hideCursor);
        }
    }


    handleClick = () => {
        const angle = getCursorLocationAngle(this.circularPath.node());
        this.props.onClick('seek', angle / 360 * this.props.studioStore.absBeatCount);
    };

    showCursor = () => {
        this.pathEl.attr('class', 'studio-player-seek-cursor show');
    };

    hideCursor = () => {
        this.pathEl.attr('class', 'studio-player-seek-cursor hide');
    };

    moveCursor = () => {
        if (device.ipad()) {
            this.pathEl.attr('class', 'studio-player-seek-cursor hide');
        }
        const angle = getCursorLocationAngle(this.circularPath.node());
        this.pathEl.attr('transform', `rotate(${angle})`);
    };

    render() {
        return (
            <g id={'studio-player-cursor-g'}>
                <line className='studio-player-seek-cursor' x1={0} y1={0} x2={0} y2={-getOuterRadius(6) - 4}/>
            </g>
        );

    }
}

StudioPlayerSeekCursor.propTypes = {
    onClick: PropTypes.func.isRequired,
    mobileView: PropTypes.bool,
};

export default StudioPlayerSeekCursor;
